export default {
  WAITING: 'waiting',
  SUCCESS: 'success',
  ERROR: 'error'
}
